module.exports = __webpack_public_path__ + "img/star.a1baee89.svg";